module.exports = __webpack_public_path__ + "img/EESTECmap.44aaefe7.png";